<!-- 待完善 动态树形 -->
<template>
    <div class="tree-box">
        <el-tree
            class="tree"
            :data="data"
            :icon-class="iconClass"
            :show-checkbox="checkbox"
            :node-key="keyField"
            :default-expand-all="defaultExpandAll"
            ref="tree"
            highlight-current
            :props="prop"
            :lazy="lazy"
            :load="load"
            :default-checked-keys="defaultCheckedKeys"
            :default-expanded-keys="defaultExpandedKeys"
            :expand-on-click-node="expandOnClickNode"
            :filter-node-method="filterNode"
            :current-node-key="currentNodeKey"
            @node-click="nodeClick"
            @node-drag-leave="handleDragLeave"
            @node-drag-over="handleDragOver"
            @node-drag-end="handleDragEnd"
            @node-drop="handleDrop"
            @check="check"
            @check-change="checkChange"
            :draggable="draggable"
            :allow-drop="allowDrop"
            :allow-drag="allowDrag"
            :render-content="renderContent">
        </el-tree>
    </div>
</template>

<script>
    export default {
        name: "Tree",
        props: {
            data: {
                type: Array, // 渲染树的数据
                required: true
            },
            prop: {
                type: Object, // 数据的属性对应值
            },
            lazy: {
                type: Boolean, // 是否懒加载子节点，需与 load 方法结合使用
                default: false
            },
            load: {
              type: Function
            },
            checkbox: {
                type: Boolean, // 是否显示多选框
                default: false
            },
            defaultExpandAll: {
                type: Boolean, // 是否默认展开所有节点
                default: false
            },
            iconClass: {
                type: String, // 树图标类名
                default: ''
            },
            keyField: {
                type: String, // 数据的标识  用于getCheckedKeys方法
                required: true
            },
            draggable: {
                type: Boolean,  // 是否允许拖拽
                default: false
            },
            allowDrop: {
                type: Function  // 拖拽时判定目标节点能否被放置
            },
            allowDrag: {
                type: Function // 判断节点能否被拖拽
            },
            expandOnClickNode: {
                type: Boolean,  // 是否在点击节点的时候展开或者收缩节点， 默认值为 true
                default: true
            },
            filterNode: {
                type: Function // 过滤函数
            },
            defaultCheckedKeys: { // 默认选中的keys
              type: Array,
              default: () => ([])
            },
            defaultExpandedKeys: { // 默认展开的节点的 key 的数组
              type: Array,
              default: () => ([])
            },
            currentNodeKey: [String, Number]
        },
        methods: {
            loadNode(node, resolve) {
                this.$emit('loadNode', node, resolve) // 叶子节点点击传出值
            },
            nodeClick(data, node) {
                this.$emit('change', data, node) // 叶子节点点击传出值
            },
            /**
             * 获取选中的节点
             * @returns {*}
             */
            getCheckedNodes() {
                return this.$refs.tree.getCheckedNodes()
            },
            /**
             * 获取选中的节点key值  （key 为keyField属性的值）
             * @returns {*}
             */
            getCheckedKeys() {
                return this.$refs.tree.getCheckedKeys()
            },
            /**
             * 取消选择
             */
            resetChecked() {
                this.$refs.tree.setCheckedKeys([]);
            },
            handleDragLeave(draggingNode, dropNode) {
                this.$emit('handleDragLeave', draggingNode, dropNode)
                console.log('tree drag leave: ', dropNode.label);
            },
            check(data,node) {
                this.$emit('check', data, node)
            },
            checkChange(obj,check,child) {
                this.$emit('checkChange', obj, check,child)
            },
            handleDragOver(draggingNode, dropNode) {
                this.$emit('handleDragOver', draggingNode, dropNode)
                console.log('tree drag over: ', dropNode.label);
            },
            handleDragEnd(draggingNode, dropNode, dropType) {
                this.$emit('handleDragEnd', draggingNode, dropNode, dropType)
                console.log('tree drag end: ', dropNode && dropNode.label, dropType);
            },
            handleDrop(draggingNode, dropNode, dropType) {
                this.$emit('handleDrop', draggingNode, dropNode, dropType)
                console.log('tree drop: ', dropNode.label, dropType);
            },
            renderContent(h, {node, data, store}) {
                return (<span class = {`${!this.checkbox ? 'el-tree-node__label' : ''} ${data.disabled ? 'is-disabled' : ''}`}><i class = {data.icon}></i>{node.label}</span>);
                // return (<span> <i class = {data.icon}></i> <span> {node.label} </span> </span>);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tree-box {
        min-width: 150px;
    }
    /deep/ .el-tree-node__label {
      font-weight: normal;
  }

  /deep/ .el-tree .is-current .el-tree-node__label {
      color: #409EFF;
      font-weight: 700;
  }

  /deep/ .el-tree .is-current .el-tree-node__children .el-tree-node__label {
      color: #606266;
      font-weight: normal;
  }

  /deep/ .el-tree .el-tree-node__children .el-tree-node__content .is-disabled {
      cursor: not-allowed;
  }
</style>